import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';
import Colors from '../../../../shared/assets/style/default/color';

const DiskCapacityInnerBar = styled.div<{ width: number }>`
  width: ${(props) => props.width * 100}%;
  height: ${90 * Screen.widthRatio}px;
  background: ${Colors.progress.fill};
`;

export default withAnimation(DiskCapacityInnerBar);
